export default __webpack_public_path__ + "static/media/RemolqueDoble VIP3.ea3dfdca.png";